import React from 'react';

import { makeStyles } from '@material-ui/styles';
import { Button } from '@material-ui/core';

const useStyles = makeStyles( (theme) => ({
  root: {
    color: theme.palette.error.main,
    backgroundColor: theme.palette.neutral.light3,
    '&:hover': {
      textDecoration: 'none',
      color: theme.palette.error.light1,
      backgroundColor: theme.palette.error.light,
    }
  }
}))

// Custom styling for MUI Button when used in a "warning" context
export const WarningButton = (props) => {
  const classes = useStyles();

  return <Button className={classes.root} {...props}>{props.children}</Button>

}